// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3QfQ5","right":"Footer_right__Y02oa","buttons":"Footer_buttons__3U11O"};